import React, { forwardRef } from 'react';
import { Checkbox } from 'zarm';
import classnames from 'classnames';

import UItem from '../item';
import { clearObj } from '../../utils/tools';
import { BaseWidgetProps, OptionsProps } from '../../utils/type';

const { Group: CheckboxGroup } = Checkbox;

export interface RadioProps extends BaseWidgetProps {
  value?: any;
  defaultValue?: any;
  size: 'lg' | 'md' | 'sm' | 'xs';
  label?: string;
  options: OptionsProps;
  type: 'button'|'cell';
  shape: 'rect'|'radius'|'round';
  isFlex?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  readOnly?: boolean;
  className?: string;
  cascade?: any;
  warnRules?: any;
  validate?: {
    rules: any[];
  };
}

// radio组件单元
const RadioGroupItem = forwardRef((props: RadioProps, ref: any) => {
  const {
    prefixCls,
    className,
    isFlex,
    options = [],
    readOnly,
    onChange,
    ...restProps
  } = props;

  const { value, defaultValue } = props;

  if (!(options && Array.isArray(options) && options.length)) {
    return null;
  }

  // 只读
  if (readOnly) {
    const values = options.filter((item) => !!~(value || defaultValue).indexOf(item.value)) || [];
    const len = values.length;

    return (
      <>
        {values.length ? values.map((item, key) => `${item.label}${key < len - 1 ? '、' : ''}`) : null}
      </>
    );
  }

  const cls = classnames(`${prefixCls}-group`, className, {
    [`${prefixCls}-flex`]: isFlex,
  });

  return (
    <CheckboxGroup
      {...restProps}
      ref={ref}
      onChange={onChange}
      className={cls}
    >
      {
        options.map((item) => (
          <Checkbox
            value={item.value}
            key={item.value}
            disabled={item.disabled}
          >
            {item.label}
          </Checkbox>
        ))
      }
    </CheckboxGroup>
  );
});

// 表单 输入框组件
function UIndex(props: RadioProps) {
  const {
    type = 'button',
    value,
    defaultValue,
    disabled,
    readOnly,
    readonly,
    prefixCls = 'crm-checkbox',
    className,
    options,
    shape,
    size = 'xs',
    _crengine,
    ...rest
  } = props;

  // 子项内容改变的时候进行数据更新
  function onValueChange(e: any) {
    const { onChange, ...otherProps } = props;

    if (onChange) {
      onChange({
        ...otherProps,
        value: e,
      });
    }
  }

  const radioProps = clearObj({
    type,
    value,
    defaultValue,
    size,
    disabled,
    options,
    shape,
    prefixCls,
    className,
    readOnly: readOnly || readonly,
    onChange: onValueChange,
  });

  const { form } = _crengine || {};

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete radioProps.value;
    delete radioProps.defaultValue;
    delete radioProps.onChange;
  }

  // 标题单独块
  // const cls = (options && Array.isArray(options) && options.length > 2) ? 'crm-form-item-display' : '';

  return (
    <UItem
      {...rest}
      itemType="checkbox"
      prefixCls={prefixCls}
      // className={cls}
      _crengine={_crengine}
      initialValue={value || defaultValue}
      validateTrigger="onChange"
      onChange={onValueChange}
    >
      <RadioGroupItem {...radioProps} />
    </UItem>
  );
}

export default UIndex;
